export default "__VITE_ASSET__4e5e3625__"